import { ApiGetRequest } from "./api-get-request";
import { ApiParameters } from "./api-parameters";

export class OpeningHoursRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string) 
    {
        super(
            "openinghours", 
            new ApiParameters(), 
            null, 
            webapiBasepath
        );
    }
}

